import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import WaitDialog from "../../widgets/WaitDialog";
import getDashboard from "../../services/getDashboard";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import getLeads from "../../services/getLeads";
import Modal from "../../widgets/Modal";
import getTag from "../../services/getTag";
import getCategorieTag from "../../services/getCategorieTag";
import TableSection from "./TableSection";
import { PieChartsSection } from "./PieChartDashboard";
import moment from "moment";
import generateExcel from "../../services/generateExcel";
import Constants from "../../utils/consts";
import SelectInput from "../../widgets/SelectInput";
import SelectInputDashboard from "./SelectInputDashboard";

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      leads: [],
      selectedTable: null,
      selectedVersion: null,
      referenceDate: new Date(),
      tableNames: [],
      isLoading: false,
      showCharts: false,
      showModale: false,
      lead: [],
      modalName: "",
      excludedCourses: [],
    };

    this.grid = 2;

    this.pdfElements = [];

    this.pageTitle = "Dashboard";

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });
  }

  async reload() {
    this.setState({ isLoading: true });

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const { referenceDate } = this.state;

    const formatDate = (date) => date.toISOString().split("T")[0];
    const formattedDate = formatDate(referenceDate);

    this.dashboard = await getDashboard(username, token, formattedDate);
    this.leads = await getLeads(username, token);

    this.tag = await getTag(username, token);
    this.categoriaTag = await getCategorieTag(username, token);

    const tableNames = (this.dashboard?.data || []).map((item) => ({
      label: item.table_name,
      value: item.table_name,
    }));

    this.setState({ tableNames, isLoading: false });
  }

  async componentDidMount() {
    await this.reload();
  }

  handlePrevious = async () => {
    this.setState(
      (prevState) => ({
        referenceDate: new Date(
          prevState.referenceDate.setDate(
            prevState.referenceDate.getDate() - 7,
          ),
        ),
      }),
      () => this.reload(),
    );
  };

  handleNext = async () => {
    this.setState(
      (prevState) => ({
        referenceDate: new Date(
          prevState.referenceDate.setDate(
            prevState.referenceDate.getDate() + 7,
          ),
        ),
      }),
      () => this.reload(),
    );
  };

  async componentDidMount() {
    await this.reload();
  }

  toggleView = () => {
    this.setState((prevState) => ({
      showCharts: !prevState.showCharts,
    }));
  };

  findLead = (row, col, table) => {
    if (!table || !table.data || !table.data[row] || !table.data[row][col]) {
      console.error("Invalid row or column specified");
      return [];
    }

    const result = table.data[row][col];
    if (result && result.ids && Array.isArray(result.ids)) {
      const foundLeads = this.leads
        .filter((lead) => result.ids.includes(lead.id))
        .map((lead) => {
          const leadTagIds = lead.tag_id.split(",").map(Number);

          const leadTags = this.tag
            .filter((tag) => leadTagIds.includes(tag.id))
            .map((tag) => {
              const category = this.categoriaTag.find(
                (categoria) => categoria.id === tag.id_categoria,
              );
              return {
                ...tag,
                categoryName: category ? category.nome : "Unknown Category",
              };
            });

          const tagsByCategory = leadTags.reduce((acc, tag) => {
            const categoryName = tag.categoryName;
            if (!acc[categoryName]) {
              acc[categoryName] = [];
            }
            acc[categoryName].push(tag.tag);
            return acc;
          }, {});

          const categoryTags = Object.entries(tagsByCategory).map(
            ([category, tags]) => ({
              category,
              tags: tags.join(", "),
            }),
          );

          return {
            ...lead,
            tags: categoryTags,
          };
        });

      if (foundLeads.length > 0) {
        this.setState({
          showModale: true,
          lead: foundLeads,
          modalName: `${row} - ${col}`,
        });
      }

      return foundLeads;
    } else {
      console.error("No IDs found in the specified row and column");
      return [];
    }
  };

  findLeadChart = (ids, corso, provenienza) => {
    if (!ids || !Array.isArray(ids)) {
      console.error("Invalid IDs provided");
      return [];
    }

    const foundLeads = this.leads
      .filter((lead) => ids.includes(lead.id))
      .map((lead) => {
        const leadTagIds = lead.tag_id.split(",").map(Number);

        const leadTags = this.tag
          .filter((tag) => leadTagIds.includes(tag.id))
          .map((tag) => {
            const category = this.categoriaTag.find(
              (categoria) => categoria.id === tag.id_categoria,
            );
            return {
              ...tag,
              categoryName: category ? category.nome : "Unknown Category",
            };
          });

        const tagsByCategory = leadTags.reduce((acc, tag) => {
          const categoryName = tag.categoryName;
          if (!acc[categoryName]) {
            acc[categoryName] = [];
          }
          acc[categoryName].push(tag.tag);
          return acc;
        }, {});

        const categoryTags = Object.entries(tagsByCategory).map(
          ([category, tags]) => ({
            category,
            tags: tags.join(", "),
          }),
        );

        return {
          ...lead,
          tags: categoryTags,
        };
      });

    if (foundLeads.length > 0) {
      this.setState({
        showModale: true,
        lead: foundLeads,
        modalName: `${corso} - ${provenienza}`,
      });
    } else {
      console.error("No leads found for the provided IDs");
    }

    return foundLeads;
  };

  download = async (tab, headCell) => {
    this.setState({ loading: true });

    // Costruisce dinamicamente le colonne dal headCell (tag attuali del corso),
    // così se il nome del tag viene cambiato l'export continua a funzionare.
    const courseColumns = (headCell || []).filter((c) => c.id !== "prov");

    const jsonTabs = tab.map((tableComponent) => {
      const headerRow = ["PROV", ...courseColumns.map((c) => ` ${c.label} `)];
      const jsonData = [headerRow];

      Object.entries(tableComponent.data).forEach(([key, value]) => {
        const row = [key];
        courseColumns.forEach((c) => {
          // Prima prova con dataKey (nome attuale del tag), poi con id come fallback
          const cellData =
            (value && c.dataKey && value[c.dataKey]) ||
            (value && value[c.label]) ||
            (value && value[c.id]);
          row.push(cellData ? cellData.count : 0);
        });
        jsonData.push(row);
      });

      function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
      }

      jsonData.push(["", ""]);
      jsonData.push([
        "Intervallo:",
        formatDate(tableComponent.interval.valid),
        formatDate(tableComponent.interval.new_end),
      ]);
      jsonData.push([
        "Data di creazione report:",
        moment().format("DD/MM/yyyy HH:mm"),
      ]);

      return {
        name: tableComponent.name,
        data: jsonData,
      };
    });

    const json = {
      tabs: jsonTabs,
    };

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      await generateExcel(username, token, JSON.stringify(json), "dashboard");

      // Piccolo delay per assicurarsi che il file sia stato generato sul server
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Apri il file in una nuova tab
      window.open(`${Constants.mainUrl}pdf/dashboard.xlsx`, "_blank");
    } catch (error) {
      console.error("Errore durante la generazione dell'Excel:", error);
      alert("Si è verificato un errore durante l'esportazione del file.");
    }

    this.setState({ loading: false });
  };

  render() {
    const tables = this.dashboard?.data || [];
    const interval = this.dashboard?.interval || {};

    const { showCharts, showModale } = this.state;

    const { excludedCourses } = this.state;

    const tableComponents = tables.flatMap((table) => [
      {
        name: `${table.table_name}`,
        data: table.leads,
        interval,
      },
    ]);

    const searchCols = [
      "prov",
      "TR",
      "R",
      "OP",
      "DOPP",
      "TS",
      "HS",
      "AD",
      "BARBE",
      "MONOLOGO",
      "SFX",
      "TEMP",
    ];

    const formatDate = (date) => {
      if (!date) return "Non disponibile";
      const d = new Date(date);
      return `${d
        .getDate()
        .toString()
        .padStart(2, "0")}/${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${d.getFullYear()}`;
    };

    const courseKeys = [
      "AD",
      "BARBE",
      "DOPP",
      "HS",
      "MONOLOGO",
      "OP",
      "R",
      "SFX",
      "TEMPTU",
      "TR",
      "TS",
    ];
    const provenanceKeys = ["FB", "IG", "NC", "PASS", "SI", "TIK"];

    const obiezioni = [
      "COSTOSO",
      "ETA",
      "LAVORA",
      "LONT",
      "NO DIPLOMA",
      "NO INGLESE",
      "NON RESID",
      "NR",
      "NUM INES",
      "PROX ANNO",
      "RICHIAM",
    ];

    // Mappa abbreviazioni per i tag CORSO (chiave = id tag, stabile rispetto a rename)
    const courseAbbreviations = {
      14: "TR",
      15: "TS",
      16: "OP",
      17: "R",
      18: "DOPP",
      19: "HS",
      20: "AD",
      21: "MONO",
      22: "BARBE",
      23: "TEMP",
      51: "SFX",
      94: "SD",
      119: "MAST",
      128: "DIAL",
    };

    // Ordine fisso di visualizzazione (come vecchia dashboard).
    // Tag non presenti in questa lista vengono accodati alla fine
    // nell'ordine in cui arrivano dal backend.
    const courseOrder = [
      14,
      17,
      16,
      18,
      15,
      19,
      20,
      22,
      21,
      51,
      23,
      94,
      119,
      128,
    ];

    const courseTags = (this.tag || [])
      .filter((t) => Number(t.id_categoria) === 3 && Number(t.active) === 1)
      .slice()
      .sort((a, b) => {
        const ia = courseOrder.indexOf(Number(a.id));
        const ib = courseOrder.indexOf(Number(b.id));
        const va = ia === -1 ? 999 : ia;
        const vb = ib === -1 ? 999 : ib;
        return va - vb;
      });

    const headCell = [
      { id: "prov", numeric: true, disablePadding: false, label: "" },
      ...courseTags.map((t) => ({
        id: String(t.id),
        tagId: t.id,
        // dataKey = nome corrente del tag, usato per leggere i dati dal backend
        dataKey: t.tag,
        numeric: true,
        disablePadding: false,
        // label = abbreviazione se presente, altrimenti il nome pieno come fallback
        label: courseAbbreviations[t.id] || t.tag,
      })),
    ];

    const handleExcludeCourses = (selectedOptions) => {
      const excludedCourses = selectedOptions || [];
      this.setState({ excludedCourses });
    };

    const filteredHeadCell = () => {
      const excludedCourseIds = this.state.excludedCourses.map(
        (course) => course.id,
      );
      return headCell.filter((cell) => !excludedCourseIds.includes(cell.id));
    };

    const corsiOptions = headCell
      .filter(
        (cell) =>
          cell.id !== "prov" &&
          !this.state.excludedCourses.some((course) => course.id === cell.id),
      )
      .map((cell) => ({
        id: cell.id,
        label: cell.label,
      }));

    return (
      <LoadingOverlay
        active={this.state.isLoading}
        styles={{
          content: (base) => ({
            position: "relative",
            width: "100%",
            top: "200px",
          }),
        }}
        spinner
        text={"Caricamento dati dashboard..."}
      >
        <PageTitle
          title={this.pageTitle}
          button={(() => {
            const cookies = new Cookies();
            const userType = cookies.get("userType", { path: "/" });
            return userType == 4
              ? null
              : this.state.showCharts
              ? "TABELLE"
              : "GRAFICO A TORTA";
          })()}
          secondButton={(() => {
            const cookies = new Cookies();
            const userType = cookies.get("userType", { path: "/" });
            return userType == 4 ? null : "ESPORTA";
          })()}
          onClick={this.toggleView}
          onSecondClick={() => {
            this.download(tableComponents, filteredHeadCell());
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "-30px",
          }}
        >
          <ArrowBack onClick={this.handlePrevious} />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
              fontStyle: "italic",
              fontSize: "0.9em",
              margin: "0 20px",
            }}
          >
            <p style={{ textAlign: "center" }}>
              Intervallo di tempo: <br />
              {tableComponents.length > 0
                ? formatDate(tableComponents[0].interval?.valid) +
                  " - " +
                  formatDate(tableComponents[0].interval?.new_end)
                : "Non disponibile"}
            </p>
          </div>

          <ArrowForward onClick={this.handleNext} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: showCharts ? "row" : "column",
            flexWrap: showCharts ? "wrap" : "nowrap",
          }}
        >
          {showCharts ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
              }}
            >
              {tableComponents.map((table, idx) => {
                return (
                  <PieChartsSection
                    key={idx}
                    table={table}
                    courseKeys={courseKeys}
                    provenanceKeys={
                      table.name === "Non buone" ? obiezioni : provenanceKeys
                    }
                    name={table.name}
                    findLeadChart={this.findLeadChart}
                  />
                );
              })}
            </div>
          ) : (
            <>
              <div
                style={{
                  marginBottom: 10,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div>
                  <SelectInputDashboard
                    value={excludedCourses}
                    name="Escludi Corso"
                    hidable={false}
                    options={corsiOptions}
                    isMulti={true}
                    onChange={handleExcludeCourses}
                  />
                </div>
              </div>
              {tableComponents.map((table, idx) => (
                <TableSection
                  key={idx}
                  tables={[table]}
                  titleFilter={table.name}
                  searchCols={searchCols}
                  onCellClick={this.findLead}
                  headCell={filteredHeadCell()}
                />
              ))}
            </>
          )}
          {showModale && (
            <Modal
              isOpen={showModale}
              onClose={() => this.setState({ showModale: false })}
              title={`${this.state.modalName}`}
              lead={this.state.lead}
            />
          )}
        </div>

        <WaitDialog
          show={this.state.waitDialogVisible}
          key={Math.random()}
          index={this.state.index}
        />
      </LoadingOverlay>
    );
  }
}
